import IViagemPedagioDTO from '../entities/IViagemPedagioDTO'
import { IValePedagioRepository } from '../repositories/IValePedagioRepository'

export interface IFiltroViagens {
  cte?: string
  placa?: string
}

export interface IFindViagensComVPO {
  execute(
    documento: string,
    filtro: IFiltroViagens,
  ): Promise<IViagemPedagioDTO[]>
}

export default class FindViagensComVPOImpl implements IFindViagensComVPO {
  constructor(private readonly repository: IValePedagioRepository) {}
  async execute(
    documento: string,
    filtro: IFiltroViagens,
  ): Promise<IViagemPedagioDTO[]> {
    return this.repository.findViagensComVPOMotorista(documento, filtro)
  }
}
